import React from "react";
//Material imports
import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import IconButton from "@material-ui/core/IconButton"; //Limitless imports

import ToolTip from "../../tooltip/Tooltip";
import { useTranslation } from "../../../../common/hooks/translation/TranslationContext";
var useStyles = makeStyles(function (theme) {
  var labelColor = theme.palette.input ? theme.palette.input.label.color : theme.palette.primary.dark;
  return {
    container: {
      display: "flex"
    },
    noGutterContainer: {
      display: "flex"
    },
    input: {
      "&:-webkit-autofill": {
        boxShadow: "0 0 0 30px white inset",
        color: theme.palette.primary.main
      },
      "@media screen and (max-width: 450px)": {
        fontSize: 16
      }
    },
    iconButton: {
      zIndex: 1,
      width: 23,
      height: 23,
      "&:hover": {
        backgroundColor: "inherit"
      }
    },
    multilineRoot: {
      padding: "6px 0 3px"
    },
    inputMultiline: {
      overflow: "auto"
    },
    adornmentMultiline: {
      alignItems: "flex-start",
      marginBottom: 10
    },
    "@media screen and (min-width: 450px)": {
      container: {
        marginBottom: 10
      }
    },
    "@media screen and (max-width: 450px)": {
      adornmentMultiline: {
        alignItems: "unset",
        height: "unset"
      }
    },
    fixedHeightError: {
      height: 24
    },
    formLabel: {
      color: labelColor,
      "&.Mui-error": {
        color: labelColor
      },
      "&.Mui-focused": {
        color: labelColor
      }
    }
  };
});

var InputField = function InputField(_ref) {
  var value = _ref.value,
      onChangeHandle = _ref.onChangeHandle,
      label = _ref.label,
      icon = _ref.icon,
      loading = _ref.loading,
      errorMessage = _ref.errorMessage,
      toolTipTitle = _ref.toolTipTitle,
      multiline = _ref.multiline,
      rows = _ref.rows,
      rootStyles = _ref.rootStyles,
      type = _ref.type,
      input = _ref.input,
      noGutterBottom = _ref.noGutterBottom,
      id = _ref.id,
      autoComplete = _ref.autoComplete,
      largeHelperMessage = _ref.largeHelperMessage,
      inputAdornmentClass = _ref.inputAdornmentClass;
  var classes = useStyles();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var handleChange = function handleChange(event) {
    var val = event.target.value;
    onChangeHandle(val);
  };

  var large = rows > 3;
  return /*#__PURE__*/React.createElement(FormControl, {
    className: noGutterBottom ? classes.noGutterContainer : classes.container,
    error: errorMessage ? true : false
  }, /*#__PURE__*/React.createElement(InputLabel, {
    classes: {
      root: classes.formLabel
    }
  }, t(label)), /*#__PURE__*/React.createElement(Input, Object.assign({
    id: id ? id : label,
    value: value,
    endAdornment: !large ? /*#__PURE__*/React.createElement(ToolTip, {
      title: toolTipTitle
    }, /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end",
      classes: multiline ? {
        root: "".concat(classes.adornmentMultiline, " ").concat(inputAdornmentClass)
      } : {}
    }, /*#__PURE__*/React.createElement(IconButton, {
      className: classes.iconButton,
      component: "div",
      tabIndex: "-1",
      disableRipple: true
    }, icon))) : null,
    onChange: handleChange,
    disabled: loading,
    multiline: multiline,
    rows: rows,
    style: rootStyles,
    classes: {
      input: classes.input,
      inputMultiline: classes.inputMultiline,
      multiline: classes.multilineRoot
    },
    type: type,
    autoComplete: autoComplete
  }, input, {
    inputProps: {
      "aria-label": label
    }
  })), /*#__PURE__*/React.createElement(FormHelperText, {
    component: "div",
    className: "".concat(largeHelperMessage && classes.fixedHeightError)
  }, t(errorMessage)));
};

export default InputField;
InputField.defaultProps = {
  noGutterBottom: false,
  autoComplete: "off",
  largeHelperMessage: false,
  inputAdornmentClass: ""
};